import { getAuthConfig } from '../../../../config/auth-config'
import { AuthContentService } from '../../../../utils/auth-content-service'
import { EntitlementService } from '../../../../utils/auth/entitlement-service'
import { initializeGbpe } from '../../../../utils/initialize-gbpe'
import { createPortableExperiences, getBaseHeadlessAuth } from '../../../../utils/portable-experiences'
import { Overlay } from '../../../overlay'
import { UltiumOverlay } from '../../../ultium-overlay'
import { checkMissingInfo } from '../../user-info/missing-info-api'
import { UserInformation } from '../../user-info/user-info'
import { NavConfig } from '../base'

export function initDefaultGbpe(config: NavConfig, missingInfo = true): void {
	const authConfig = getAuthConfig(config)
	const userInfo: UserInformation = new UserInformation(config.urls)

	const baseGbpeObject = createPortableExperiences(
		authConfig,
		userInfo,
		getBaseHeadlessAuth(authConfig, config.urls, authConfig.sessionStorageKeyPrefix),
		new Overlay(document.body),
		config.urls,
		new EntitlementService(),
		new AuthContentService()
	)

	initializeGbpe(authConfig, userInfo, config, baseGbpeObject)

	if (missingInfo === true) {
		checkMissingInfo().then()
	}
}

export function initDefaultGbpeUltiumOverlay(config: NavConfig, missingInfo = true): void {
	const authConfig = getAuthConfig(config)
	const userInfo: UserInformation = new UserInformation(config.urls)

	const baseGbpeObject = createPortableExperiences(
		authConfig,
		userInfo,
		getBaseHeadlessAuth(authConfig, config.urls, authConfig.sessionStorageKeyPrefix),
		new UltiumOverlay(document.body),
		config.urls,
		new EntitlementService(),
		new AuthContentService()
	)

	initializeGbpe(authConfig, userInfo, config, baseGbpeObject)

	if (missingInfo === true) {
		checkMissingInfo().then()
	}
}
